// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";
import "../static/css/weui/weui.min.css";
import "./assets/common/rem";
import "./assets/common/reset.css";
import "./assets/common/main.css";
import "../static/lib/layer_mobile/need/layer.css";
import axios from "axios";
import VueCookies from "vue-cookies";
import wx from "weixin-js-sdk";
import lazyload from "vue-lazyload";
//import layer from "vue2-layer-mobile";
import layer from "../static/lib/layer_mobile/layer.js";
import ScrollPosition from "./util/scroll-position";
Vue.config.ignoredElements = ["wx-open-launch-weapp"]; ///忽略Vue对微信开放标签的检查。
var eventBus = {
  install(Vue, options) {
    Vue.prototype.$bus = new Vue();
  }
};
Vue.use(eventBus);
Vue.use(layer);
Vue.use(VueCookies);
Vue.use(lazyload, {
  error: require("./assets/load.png"),
  loading: require("./assets/load.png")
});

import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
Vue.use(Viewer, {
  defaultOptions: {
    toolbar: false,
    navbar: false,
    title: false
  }
});

//图片浏览器
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
Vue.use(preview, {
  fullscreenEl: false,
  arrowEl: false,
  mainClass: "main",
  showHideOpacity: true,
  isClickableElement: function(el) {
    console.log(el);
    return el.tagName === "DIV" || el.tagName === "IMG";
  }
});

//设置网页标题
import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);
//注册全局指令
// 注册一个全局自定义指令 `v-focus`
Vue.directive("focus", {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function(el) {
    // 聚焦元素
    el.focus();
  }
});
import clipboard from "clipboard"; //复制粘贴功能实现
//注册到vue原型上
Vue.prototype.clipboard = clipboard;
import global from "./components/common/common";
Vue.prototype.GLOBAL = global;
Vue.prototype.WX = wx;
axios.defaults.baseURL = global.BASE_URL;

Vue.prototype.$ajax = axios;
import util from "./util/util";
Vue.prototype.COMMON = util;
Vue.config.productionTip = false;
global.openid = localStorage.getItem("_uuid");
import store from "../static/lib/store";
const CancelToken = axios.CancelToken;
//引入jwt加密
//jsrsasign支持的签名方式 https://kjur.github.io/jsrsasign/api/symbols/KJUR.crypto.Signature.html
import jsrsasign from "jsrsasign";
//由于jsrsasign支持的签名方式不支持HmacSHA256需要使用原版crypto
import CryptoJS from "crypto-js/crypto-js";
import { Agent } from "https";
var Base64 = require("js-base64").Base64;
const jwt = require("jsonwebtoken");
Vue.prototype.$getCode = function(newStr) {
  //此处操作与后端约定参数

  // 创建RSAKey对象
  let rsa = new jsrsasign.RSAKey();
  //因为后端提供的是pck#8的密钥对，所以这里使用 KEYUTIL.getKey来解析密钥
  let private_key = "swdQ41sfg3EFTwddhjndf45g";
  let k =
    "-----BEGIN PRIVATE KEY-----" + private_key + "-----END PRIVATE KEY-----";
  // 将密钥转码
  rsa = jsrsasign.KEYUTIL.getKey(k);
  // 创建Signature对象，设置签名编码算法
  let sig = new jsrsasign.KJUR.crypto.Signature({
    alg: "SHA256withRSA",
    prov: "cryptojs/jsrsa"
  });
  // 初始化
  sig.init(rsa);
  // 传入待加密字符串
  sig.updateString(newStr);
  // 生成密文
  var sign = jsrsasign.hextob64(sig.sign());
  // 对加密后内容进行URI编码
  sign = encodeURIComponent(sign);
  //把参数与密文拼接好，返回
  //var params = newStr + "&sign=" + sign;
  var params = sign;
  return params;
};
// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 这个是取消重点
    config.cancelToken = new CancelToken(cancel => {
      store._axiosPromiseCancel.push(cancel);
    });
    //获取token
    const token = localStorage.getItem("TOKEN");
    //过滤掉登陆接口以及新手指南接口
    let filterArr = [
      "WXLoginByCode",
      "NewerGuide",
      "getTestToken",
      "token",
      "getToken"
    ];
    let results = [];
    filterArr.forEach((item, index) => {
      if (config.url.indexOf(item) >= 0) {
        results.push(item);
      }
    });
    if (results.length === 0) {
      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded;charset=UTF-8";
      // Bearer是JWT的认证头部信息
      config.headers.common["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.StatusCode === 403) {
      //token验证不通过
      //清除所有登录信息防止进入不了登录页面
      localStorage.removeItem("code");
      localStorage.removeItem("TOKEN");
      localStorage.removeItem("user");
      localStorage.removeItem("openid");
      localStorage.removeItem("_uuid");
      let wx = global.isweixin();
      if (wx) {
        //微信端与h5端认证方式不一样
        layer.open({
          content: "请稍候，正在重新登录",
          skin: "msg",
          time: 1 //2秒后自动关闭
        });
        localStorage.setItem("now_url", router.currentRoute.fullPath); //当前页url与参数放入缓存
        router.replace({
          path: "/home/auth"
        });
      } else {
        layer.open({
          content: "请求验证未通过，请重新登录",
          skin: "msg",
          time: 1 //2秒后自动关闭
        });
        //当前页url与参数放入params然后跳转到登录
        router.replace({
          name: "login",
          params: { return_url: router.currentRoute.fullPath }
        });
      }
    }
    return response;
  },
  error => {
    if (axios.isCancel(error)) {
      // 为了终结promise链 就是实际请求 不会走到.catch(rej=>{});这样就不会触发错误提示之类了。
      return new Promise(() => {});
    } else {
      if (error.response.status === 500) {
        layer.open({
          title: "出错啦",
          content: "网络异常，请重试",
          btn: "刷新",
          shadeClose: false,
          yes: function(index) {
            window.location.reload();
          }
        });
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  }
);

router.beforeEach((to, from, next) => {
  //跳转页面取消上页面的ajax
  store._axiosPromiseCancel.forEach(e => {
    e && e();
  });
  store._axiosPromiseCancel = [];
  let wx = global.isweixin();
  if (to.meta.content) {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  const _uuid = localStorage.getItem("_uuid");
  if (wx) {
    //微信端
    const openid = localStorage.getItem("openid");
    if (!openid) {
      //进入登录页面的时候清除 token
      if (to.path === "/home/auth") {
        //localStorage.setItem("now_url", "/home");
        localStorage.removeItem("code");
        localStorage.removeItem("TOKEN");
        localStorage.removeItem("user");
        localStorage.removeItem("openid");
        localStorage.removeItem("_uuid");
        next();
      } else {
        localStorage.setItem("now_url", to.fullPath); //当前页url与参数放入缓存
        next("/home/auth");
      }
    } else {
      global.setOpenid(_uuid);
      next();

      //next();
    }
  } else {
    //浏览器端
    if (to.matched.some(record => record.meta.requiresAuth)) {
      //这里判断用户是否登录
      if (!_uuid) {
        if (to.name === "login") {
          next();
          return;
        }
        next({
          name: "login",
          params: { return_url: to.fullPath }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});
router.afterEach((to, from) => {});
//混入设置用户信息的功能
Vue.mixin({
  data: function() {
    return {
      user: "",
      old_openid: "",
      uuid: "",
      mescroll: null,
      isminprogram: false
    };
  },
  methods: {
    setOldId() {
      let user = localStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
        this.user = user;
        if (user.id) {
          this.uuid = user.id;
          this.old_openid = user.union_id;
        }
      }
    },
    //判断是否是小程序环境
    getMinProgram() {
      let _this = this;
      _this.WX.miniProgram.getEnv(function(res) {
        if (res.miniprogram) {
          _this.isminprogram = true;
        }
      });
    },
    handleShowHeaderTools() {
      this.$emit("hasHeaderTools", true); //如果页面需要、就把状态传递给父组件
    },
    handleHideHeaderTools() {
      this.$emit("hasHeaderTools", false); //如果页面不需要底栏、就把状态传递给父组件
    }
  },
  created() {
    this.setOldId();
  },
  beforeRouteLeave(to, from, next) {
    layer.closeAll();
    this.$emit("shareRouteTarget", { share: false, shareType: 0 }); //所有的页面在离开之后应当通知父组件关闭分享状态
    next(); // next()记得写不然不跳转
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});
